import { createSearchParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { TipoProfissional } from "../api/getProfessionals";
import ButtonCategory from "./buttons/ButtonCategory";
import { AlterIcon, BrainIcon, StethoscopeIcon, StretcherIcon } from "./Icons";
import { useTheme } from "styled-components";

const Wrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

const QuickSearch = () => {
	const navigate = useNavigate();
	const theme = useTheme();

	const navigateToTipoProffisional = (search: TipoProfissional, focus = false) => {
		const jsonParams: { focus?: string; tipoProfissional?: string } = {};
		if (focus) jsonParams.focus = "true";
		jsonParams.tipoProfissional = search;

		navigate({
			pathname: "/medicos",
			search: createSearchParams(jsonParams).toString(),
		});
	};

	return (
		<Wrapper>
			<ButtonCategory
				style={{
					width: "50%",
					float: "left",
				}}
				icon={<StretcherIcon size={20} color={theme.colors.whiteVitat || "#000000"} />}
				label="Nutrição"
				onClick={() => navigateToTipoProffisional("nutricionista")}
			/>
		</Wrapper>
	);
};
export default QuickSearch;
